import fs from "fs";
import path from "path";
import Legal from "app/components/Legal";
import { useLoaderData } from "@remix-run/react";
import type { MetaFunction } from "@remix-run/node";
import { privacyPolicySchema } from "./seo";
import { SEOHandle } from "@nasa-gcn/remix-seo";
import { getSocialMetaTags } from "app/utils/meta";

export const meta: MetaFunction = () =>
  getSocialMetaTags({
    title: "Privacy Policy | Promotional Products Now",
    description: "Welcome to Promotional Products Now",
    url: "https://www.promotionalproductsnow.au/privacy-policy",

    extra: [
      {
        tagName: "link",
        rel: "canonical",
        href: "https://www.promotionalproductsnow.au/privacy-policy",
      },
    ],
  });

export function headers() {
  return {
    "Cache-Control": "public, max-age=86400, stale-while-revalidate=86400",
  };
}

export default function Privacy(): JSX.Element {
  const { content } = useLoaderData<typeof loader>();

  return (
    <div className="space-y-4">
      <h1 className="text-2xl md:text-3xl xl:text-4xl 2xl:text-5xl 4xl:text-6xl font-bold text-center text-foreground">
        Privacy Policy
      </h1>
      <div className="flex flex-col gap-3 w-full mx-auto p-4 lg:py-10 lg:px-5 ">
        <Legal content={content} />
      </div>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(privacyPolicySchema(content)) }}
      />
    </div>
  );
}

export function loader() {
  const privacyFilePath = path.resolve(process.cwd(), "app/contents", "privacy.md");
  const privacyContent = fs.readFileSync(privacyFilePath, "utf-8");
  return { content: privacyContent };
}

export const handle: SEOHandle = {
  getSitemapEntries: async () => [
    {
      route: "/privacy-policy",
      priority: 0.6,
      lastmod: new Date().toISOString(),
      changefreq: "monthly",
    },
  ],
};
